var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / how-step-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-18.4%",
    y: "-17.6%",
    width: "136.9%",
    height: "135.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC3E7F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E286D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.874745,8.63358101 C124.221103,6.20569326 123.40466,3.75636479 121.670841,2.02186953 C120.0948,0.509842302 117.921971,-0.212623489 115.754321,0.0546265165 C71.2029225,5.46824263 45.6879285,25.4217075 31.1037059,45.064555 L24.2849162,44.7095638 C19.3230019,44.4533264 14.4851572,46.313209 10.9727454,49.8273539 L0.32300881,60.4770905 C0.0629361683,60.7384469 -0.0502893125,61.111939 0.0208792265,61.4737124 C0.0920477656,61.8354858 0.338309049,62.1382591 0.67800003,62.2816292 L17.6584134,69.3222884 C15.7427453,74.1532611 14.2144207,79.1289717 13.0879014,84.2023371 C12.6887803,86.0303566 13.2459631,87.9359219 14.5670315,89.260962 L34.7127833,109.347549 C36.0378234,110.668617 37.9433887,111.2258 39.7714082,110.826679 L39.7714082,110.826679 C44.8446618,109.699737 49.8203392,108.171422 54.6514569,106.256167 L61.6921161,123.23658 C61.8354862,123.576271 62.1382595,123.822532 62.5000329,123.893701 C62.8618063,123.964869 63.2352983,123.851644 63.4966548,123.591571 L74.1463914,112.941835 C77.6589401,109.428386 79.5185389,104.591279 79.2641815,99.6296639 L78.9091903,92.8108742 C98.5076639,78.3893559 118.372381,52.9187358 123.874745,8.63358101 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.9129389%",
    y1: "55.2387272%",
    x2: "37.0201431%",
    y2: "77.5196698%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.5324059%",
    y1: "44.4987849%",
    x2: "50%",
    y2: "99.8812091%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.0891197,69.7956101 C79.3608636,72.5248697 75.2570969,73.341748 71.6916671,71.8652827 C68.1262373,70.3888173 65.8014165,66.9098233 65.8014165,63.0507769 C65.8014165,59.1917304 68.1262373,55.7127364 71.6916671,54.2362711 C75.2570969,52.7598057 79.3608636,53.576684 82.0891197,56.3059437 C85.8074638,60.0256346 85.81408,66.0529735 82.103911,69.7808188 L82.0891197,69.7956101 Z M88.0056401,50.4485885 C84.4112368,46.8581774 83.3342852,41.455743 85.2771782,36.7614962 C87.2200712,32.0672493 91.7999888,29.0061259 96.8804206,29.0061259 C101.960852,29.0061259 106.54077,32.0672493 108.483663,36.7614962 C110.426556,41.455743 109.349604,46.8581774 105.755201,50.4485885 C103.3968,52.8122494 100.194165,54.1393543 96.8551618,54.136583 C93.5161586,54.1338031 90.3157347,52.8013757 87.9612662,50.4337972 L88.0056401,50.4485885 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-35.5%",
    y: "-31.0%",
    width: "175.6%",
    height: "175.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "21.3434935%",
    y1: "15.1651008%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC124",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89422",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.357119,17.4000499 C8.37541288,16.3612616 5.17669446,16.1065866 2.06818208,16.6604848 C1.5299593,16.7564661 0.97860694,16.5855469 0.589051993,16.2019545 C0.0773330104,15.6998502 -0.0646442884,14.9308065 0.234060772,14.2790854 C3.45856436,7.13488706 12.3333449,-7.22746607 28.2339933,4.3689138 C28.4009337,4.52031502 28.4961437,4.73519631 28.4961437,4.96056584 C28.4961437,5.18593536 28.4009337,5.40081665 28.2339933,5.55221787 C23.8794118,8.96479241 21.4170502,14.2522741 21.6074905,19.7814493 C21.6304058,20.4415834 22.1602431,20.9714207 22.8203772,20.994336 C28.3109462,21.2141379 33.5800979,18.8155761 37.020026,14.5305375 C37.1717783,14.3482627 37.3966882,14.2428569 37.633865,14.2428569 C37.8710418,14.2428569 38.0959517,14.3482627 38.247704,14.5305375 C40.4663991,17.1781803 46.5604151,25.7719261 39.8155819,34.0846372 C36.8454558,37.6356487 32.5920832,39.8686693 27.9825412,40.2969836 C21.4004123,41.0217573 9.3011282,43.0925394 4.31645981,48.7871903 C3.91453868,49.2805146 3.27088105,49.508255 2.6481394,49.3774792 C2.02539775,49.2467035 1.52772383,48.7792835 1.35819964,48.1659556 C-0.32800866,42.1902701 -2.97565151,28.8780993 11.357119,17.4000499 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.1230923%",
    y1: "51.3752814%",
    x2: "35.5735497%",
    y2: "57.2245202%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-/-how-step-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_launch_796223",
    filter: "url(#filter-1)",
    transform: "translate(6.221758, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-30",
    transform: "translate(14.421318, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.952951,-0.5 C106.477081,26.8730581 91.3875185,48.8230846 78.6842626,65.3500794 C65.9810068,81.8770743 44.4445278,93.6092893 14.0748256,100.546725 C47.932891,120.587493 71.9682788,130.8888 86.1809891,131.450646 C100.157225,132.003144 121.013186,109.328132 127.606969,106.5 C144.258776,99.3578922 143.04077,63.6912256 123.952951,-0.5 Z",
    fillOpacity: 0.15,
    fill: "url(#linearGradient-5)",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-30",
    transform: "translate(0.000000, 95.586159)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-9)",
    fillRule: "nonzero",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2966034,18.9743347 C39.2738062,10.1918891 22.5123541,16.2897839 -4.98775287,37.2680192 C-8.67090745,41.3837231 -3.40612962,43.7224979 10.8065806,44.2843435 C24.7828166,44.8368411 36.4391241,45.372921 41.2842399,41.7915761 C54.3307991,32.1480031 54.3307991,32.1480031 45.2966034,18.9743347 Z",
    fillOpacity: 0.15,
    fill: "url(#linearGradient-12)",
    mask: "url(#mask-11)",
    transform: "translate(22.757319, 29.885059) rotate(-20.000000) translate(-22.757319, -29.885059) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowStep3);
export default __webpack_public_path__ + "static/media/how-step-3.137f27c8f6a27d3818814e895da74d4d.svg";
export { ForwardRef as ReactComponent };